<template>
  <a-modal v-model="visible"
           width="80%"
           :dialog-style="{ top: '20px' }"
           @cancel="handleCancel">
    <template slot="title">
      <span>竞价操作指引</span>
      <a-radio-group default-value="1"
                     button-style="solid"
                     class="ml-5"
                     v-model="radioValue">
        <a-radio-button value="1"
                        v-if="bidType=='1'|| bidType=='3'">
          自由竞价
        </a-radio-button>
        <a-radio-button value="2"
                        v-if="bidType=='2'|| bidType=='3'">
          单轮竞价
        </a-radio-button>
      </a-radio-group>
    </template>
    <div v-if="radioValue==='1'">
      <a-steps direction="vertical"
               size="default">
        <a-step>
          <div class="bold"
               slot="title">自由竞价规则说明</div>
          <span slot="description">
            <p>竞价供应商在竞价时限内，可以多次进行公开报价操作（竞价供应商互相可见），系统以每个竞价供应商最后一次成功报价作为该竞价供应商的最终报价。竞价结束后，系统按照“满足竞价项目要求且有效报价最低（或最高）”的原则自动确定成交竞价供应商。</p>
            <p><span class="text-bold">自由竞价方式：</span>自由竞价包括竞低价和竟高价两种方式，竞低价为最低价成交；竞高价为最高价成交。</p>
            <p><span class="text-bold">竞价时限：</span>每个竞价项目的竞价过程由常规竞价阶段和倒计时阶段组成。</p>
            <p>常规竞价时长由经办人在立项时指定，此阶段的时长是固定的，计时不受竞价供应商报价与否的影响。</p>
            <p> 常规竞价时间截止后，项目自动进入倒计时竞价阶段，此阶段内凡有竞价供应商报价，则倒计时时间自动重新开始，直到无供应商再次报价，倒计时归零为止，此时项目竞价结束。</p>
            <p><span class="text-bold">报价限制：</span>竞价供应商每次报价必须满足最低的加（减）价幅度的要求，且必须不高于最高限价（或不低于最低限价）不低于（或不高于）当前其他供应商的最高（最低）报价。</p>
            <p><span class="text-bold">项目失败条件：</span>条件一：购标竞价人数量少于竞价文件所规定的家数。
              条件二：有效报价数量少于竞价文件所规定的数量。</p>
            <p>一般情况下，系统自动根据以上两类失败条件来自动判定项目是否竞价失败。 如竞价过程中发生异常情况（如发现竞价供应商有串标行为），可以由采购人来决定项目是否失败。</p>
          </span>
        </a-step>
        <a-step>
          <div class="bold"
               slot="title">开始竞价（以下为模拟竞价页面截图）</div>
          <span slot="description">
            <img src="../../img/help/simulated_free_bidding.png">
          </span>
        </a-step>
        <a-step>
          <div class="bold"
               slot="title">正式开始竞价流程指引</div>
          <span slot="description">
            <img src="../../img/help/free_bidding.png">
          </span>
        </a-step>
        <a-step>
          <div class="bold"
               slot="title">提交报价，确认提交后将不可撤回。</div>
          <span slot="description">
            <img src="../../img/help/free_bidding_submit.png">
          </span>
        </a-step>
        <a-step>
          <div class="bold"
               slot="title">退出竞价大厅</div>
          <span slot="description">
            <img src="../../img/help/free_bidding_quit.png">
          </span>
        </a-step>
      </a-steps>
    </div>
    <div v-else>
      <a-steps direction="vertical"
               size="default">
        <a-step>
          <div class="bold"
               slot="title">单轮竞价规则说明</div>
          <span slot="description">
            <p>供应商在竞价时限内，只能进行一次报价（暗箱报价），即：在竞价时间未结束前，无法看到别的竞价人的报价（项目经办人也无法看到各个供应商的报价）。竞价时间结束后，系统自动公布所有供应商的报价，最高价（或最低价）者为成交供应商。如果出现多条相同的最高（或最低）报价，则先报价者成交。</p>
            <p>单轮竞价包括竞低价和竟高价两种方式，竞低价为最低价成交；竞高价为最高价成交。</p>
            <p><span class="text-bold">单轮竞价时限：</span>由项目经办人在立项时指定，此时长是固定的，计时不受竞价人报价与否的影响。</p>
            <p><span class="text-bold">报价限制：</span>供应商只能在竞价时限内报一次价格。竞价人报价必须不高于最高限价（或不低于最低限价）。</p>
            <p><span class="text-bold">项目失败条件：</span>条件一：购标竞价人数量少于竞价文件所规定的家数。
              条件二：有效报价数量少于竞价文件所规定的数量。</p>
            <p>一般情况下，系统自动根据以上两类失败条件来自动判定项目是否竞价失败。 如竞价过程中发生异常情况（如发现竞价人有串标行为），可以由采购人来决定项目是否失败。</p>
          </span>
        </a-step>
        <a-step>
          <div class="bold"
               slot="title">开始竞价（以下为模拟竞价页面截图）</div>
          <span slot="description">
            <img src="../../img/help/simulated_single_bidding.png">
          </span>
        </a-step>
        <a-step>
          <div class="bold"
               slot="title">正式开始竞价流程指引</div>
          <span slot="description">
            <p>1、<span class="text-bold">详细报价：</span> 若有“填写详细报价”按钮，则需填写详细报价（下图1），填写完成后可点击“预览详细报价”查看所填写的报价信息</p>
            <p>2、<span class="text-bold">报价确认函：</span>若有“盖章的报价确认函上传”按钮，则需提前编制并打印报价确认函文件并盖章，准备好电子扫描文件进行上传</p>
            <img src="../../img/help/single_bidding.png">
            <div>
              （图1）：<img src="../../img/help/single_bidding_detail.png">
            </div>
          </span>
        </a-step>
        <a-step>
          <div class="bold"
               slot="title">提交报价，确认提交后将不可撤回。</div>
          <span slot="description">
            <img src="../../img/help/single_bidding_submit.png">
          </span>
        </a-step>
        <a-step>
          <div class="bold"
               slot="title">退出竞价大厅</div>
          <span slot="description">
            <img src="../../img/help/single_bidding_quit.png">
          </span>
        </a-step>
      </a-steps>
    </div>
    <template slot="footer">
      <a-button key="back"
                @click="handleCancel"> 关闭 </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'BiddingGuidelines',
  data () {
    return {
      visible: false,
      projectId: '',
      radioValue: '1',
      bidType: '1'// 1自由，2单轮，3自由+单轮
    }
  },
  methods: {
    async initModal (projectId) {
      this.projectId = projectId
      await this.getData()
      this.visible = true
    },
    async getData () {
      // 获取该项目是单轮竞价还是自由竞价还是都有
      const res = await this.$http.get('/api/v1/supplier/packs/getPacksType?projectId=' + this.projectId)
      if (res.code === 200) {
        this.bidType = res.msg
        if (res.msg === '2') {
          this.radioValue = '2'
        } else if (res.msg === '3' || res.msg === '1') {
          this.radioValue = '1'
        }
      }
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.text-bold {
  font-weight: bold;
}
.text-indent-2 {
  text-indent: 2em;
}
/deep/ .ant-modal-body {
  padding: 5px;
  height: 38vw;
  overflow-y: scroll;
}
/deep/
  .ant-steps-item-wait
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title {
  color: #000;
}
/deep/
  .ant-steps-item-wait
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-description {
  color: rgba(0, 0, 0, 0.65);
}
/deep/ .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
  color: #fff;
}
/deep/ .ant-steps-item-wait .ant-steps-item-icon {
  background-color: rgb(24, 144, 255);
  border-color: rgb(24, 144, 255);
}
.ant-steps-item-description img {
  box-shadow: rgba(0, 0, 0, 0.2) 0 3px 9px;
  width: 830px;
  margin: 30px auto;
}
</style>
